<div class="admin-collection-modal__backdrop animated fadeIn">
	<div class="admin-collection-modal__wrapper">
		<div class="admin-collection-modal">
			<div class="admin-collection-modal__header">
				<h3 class="admin-collection-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="admin-collection-modal__content">
				<p>You are about to edit Custom Collection Cycle for {{ data?.options['org_name'] }} organization:</p>
				<form class="admin-collection admin-collection-form">
					<div class="admin-collection-form__row--composed" *ngFor="let key of Object.keys(dict.items)">
						<b class="mr-2">{{ key }}</b>

						<mat-form-field class="example-form-field">
							<mat-label>Set minutes</mat-label>
							<input matInput type="number" name="{{ key }}" [(ngModel)]="dict.items[key]" autocomplete="off" />
						</mat-form-field>
						<button class="admin-collection-form__remove" (click)="onDelete(key)"></button><br />
					</div>

					<hr />
					<mat-select
						*ngIf="awsServicesList.length"
						(selectionChange)="onChange($event.value)"
						placeholder="Select Service"
					>
						<mat-select-trigger>Select Service</mat-select-trigger>
						<mat-option *ngFor="let service of awsServicesList" [value]="service">{{ service }}</mat-option>
					</mat-select>
				</form>
			</div>
			<div class="admin-collection-modal__actions">
				<button class="admin-collection-modal__close" (click)="closeEvent()">Close</button>
				<button class="admin-collection-modal__create" (click)="onSubmit()">Apply</button>
			</div>
		</div>
	</div>
</div>
